import {createSlice} from "@reduxjs/toolkit";

const initialSelectedInstrumentState = {
  isLoading: false,
  data: {},
  notification: null
};

export const selectedInstrumentSlice = createSlice({
  name: "selectedInstrument",
  initialState: initialSelectedInstrumentState,
  reducers: {
    // Selected Instrument Responses
    instrumentNotification: (state, action) => {
      state.isLoading = false;
      state.notification = action.payload.notification;
    },
    // Selected Process Loading
    isLoading: (state, action) => {
      state.isLoading = true;
    },

    // fetchSelectedInstrument
    instrumentDetailsFetched: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  }
});
